<template>
  <div class="row">
    <div class="items-index-container col-12">
      <items-table />
    </div>
  </div>
</template>

<script>
import ItemsTable from 'VuePartials/ItemsTable';

export default {
  components: {
    ItemsTable,
  },
};
</script>
